import { useNavigate } from 'react-router-dom';
import { useQueryClient } from '@tanstack/react-query';
import { clearCsrfToken } from '../../api/csrf';
import { useLogout, useLogoutAll } from '../../auth/authQueries';
import { Alert, Button, Card, pushToast } from '../../components/ui';
import { ROUTES } from '../../lib/routes';
import { track } from '../../lib/logger';

export default function SecurityPage() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const logout = useLogout();
  const logoutAll = useLogoutAll();

  function endSession(): void {
    clearCsrfToken();
    queryClient.clear();
    navigate(ROUTES.login, { replace: true });
  }

  function handleLogout(): void {
    track('auth_logout_started', { route: ROUTES.security });
    logout.mutate(undefined, {
      onSuccess: endSession,
      onError: () => pushToast('Không thể đăng xuất. Vui lòng thử lại.', 'error'),
    });
  }

  function handleLogoutAll(): void {
    logoutAll.mutate(undefined, {
      onSuccess: ({ revokedSessionCount }) => {
        track('auth_logout_all_succeeded', { route: ROUTES.security });
        pushToast(`Đã đăng xuất khỏi ${revokedSessionCount} phiên.`, 'success');
        endSession();
      },
      onError: () => pushToast('Không thể đăng xuất tất cả. Vui lòng thử lại.', 'error'),
    });
  }

  const busy = logout.isPending || logoutAll.isPending;

  return (
    <div className="stack">
      <h1>Bảo mật</h1>

      <Card>
        <p>Bạn đang đăng nhập trên thiết bị này.</p>
        <Button
          variant="secondary"
          onClick={handleLogout}
          loading={logout.isPending}
          disabled={busy}
        >
          Đăng xuất thiết bị này
        </Button>
      </Card>

      <Card>
        <h2>Đăng xuất khỏi tất cả thiết bị</h2>
        <Alert tone="info">
          Thao tác này sẽ kết thúc mọi phiên đăng nhập, kể cả thiết bị hiện tại.
        </Alert>
        <Button
          variant="danger"
          onClick={handleLogoutAll}
          loading={logoutAll.isPending}
          disabled={busy}
        >
          Đăng xuất tất cả
        </Button>
      </Card>
    </div>
  );
}
